import _ from 'lodash';

// TO DO: need to chage all places that use this
export const ALL_TEAMS_OPTION = {
  value: 'all-teams',
  displayValue: 'All Teams',
  ignoreMaxLimit: true
};
export const isEqualAllTeams = teams => {
  return (
    _.get(teams, '[0]') === ALL_TEAMS_OPTION.value ||
    _.isEmpty(_.get(teams, '[0]'))
  );
};

export const getTeamsNames = teams =>
  isEqualAllTeams(teams)
    ? ''
    : teams.map(team => _.get(team, 'name')).join(', ');
